<template>
  <div>
    <overwatchLoader id="loader" v-if="!site" />
    <model path="/static/tribe/tribeRatesHorizontalV1/" :content="model" :format="1610"></model>
    <div id="tribeRatesHorizontalV1" class="d-flex flex-column justify-content-around" v-if="site">
      <div id="master" class>
        <div id="main">
          <div class="titleBloc">
            <div class="leftTitles d-flex flex-row justify-content-between align-items-center">
              <div class="col1 white">{{ $tlang(currentLgName, "tribe.rates.roomRatesTitle") }}*</div>
              <div class="col2" v-html="ratesLg[currentLg].periodTitle.period1"></div>
              <div
                class="col3"
                v-if="ratesLg[currentLg].periodTitle.period2 !== '<br>'"
                v-html="ratesLg[currentLg].periodTitle.period2"
              ></div>
              <div
                class="col4"
                v-if="ratesLg[currentLg].periodTitle.period3 !== '<br>'"
                v-html="ratesLg[currentLg].periodTitle.period3"
              ></div>
            </div>
          </div>
          <div class="ratesBloc d-flex flex-row justify-content-between">
            <rates class="left" :ratesLg="ratesLg[currentLg]"></rates>
            <services class="right" :servicesLg="ratesLg[currentLg]"></services>
          </div>
        </div>
        <legalNotice
          :legalNoticeLgLeft="legalNoticeLgLeft"
          :legalNoticeLgMiddle="legalNoticeLgMiddle"
        />
        <svg
          id="tribe_logo"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 250 150"
        >
          <defs />
          <path
            class="cls-1"
            d="M250,150H0V0H250ZM11,139.06h228.1V11H11ZM40.16,51.3H50.63v57.81H61.4V51.3H71.65V41.45H40.16ZM110,66.74v-12c0-9.14-5.8-13.3-13.31-13.3H79.38v67.66H90.15V80.56h4.36l5.8,28.55h11.13l-7.63-31.57C107.68,75.63,110,71,110,66.74m-19.81-16h5.58c2.54,0,3.66,1.51,3.66,4.36V67.35c0,3.26-1.42,4.78-4.06,4.78H90.15Zm30.07,58.41H131V41.45H120.22Zm45.21-34.54c4.77-1.42,6.7-5.08,6.7-10.17V54.55c0-9.14-5.48-13.1-13-13.1H141.66v67.66h17.67c7.42,0,13-3.87,13-13.11V84.73c0-5-1.93-8.54-6.91-10.16M152.53,50.7H158c2.54,0,3.76,1.51,3.76,4.36V66.13c0,3.15-1.52,4.68-4.16,4.68h-5.08Zm9.34,44.79c0,2.85-1.11,4.37-3.65,4.37h-5.69V79h5.18c2.64,0,4.16,1.73,4.16,4.77ZM182,109.11h27V99.25H192.76V78.63H204V69.69H192.76V51H209V41.45H182Z"
            transform="translate(0 0)"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from "./titles";
import LegalNotice from "./legalNotice";
import Rates from "./rates/rates";
import Services from "./services/services";
import OverwatchLoader from "../../../../loader/overwatch";
import Change from "./right/change/change";
import Hosts from "./right/hosts/hosts";
import Messages from "./right/messages/messages";
import model from "../../../../debug/model";

export default {
  name: "TribeRatesHorizontalV1",
  components: {
    pageTitles: Titles,
    legalNotice: LegalNotice,
    rates: Rates,
    services: Services,
    change: Change,
    hosts: Hosts,
    messages: Messages,
    OverwatchLoader,
    model,
  },
  data: function () {
    return {
      model: [
        "Ecran tarifs-horizontal_sur tablette_V°2 [ A ].jpg",
        "Ecran tarifs-horizontal_sur tablette_V°2 [ B ].jpg",
      ],
      currentLg: "lg1",
      lgTimeout: null,
    };
  },
  mounted() {
    this.$dm.getData(this.$route); // get data on start
    if (this.alternTimeout) {
      clearTimeout(this.alternTimeout);
    }
    this.alternTimeout = setTimeout(this.alternates, 7000);
  },
  computed: {
    ratesLg() {
      let rates = this.site && this.site.get("rates");
      if (rates) {
        let data = rates.get("data");
        if (data) {
          return {
            lg1: data[data.languages[0].id],
            lg2: data.languages[1] && data[data.languages[1].id],
          };
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    currentLgName() {
      let offset = 0;
      if (this.currentLg === "lg2") {
        offset = 1;
      }
      return this.$store.getters.site
        .get("rates")
        .get("data")
        .languages[offset].name.toLowerCase();
    },
    netStatus() {
      return this.$store.state.connected;
    },
    site() {
      let site = this.$store.getters.site;
      console.log("site()", site);
      return site;
    },
    user() {
      return this.$store.getters.user;
    },
    device() {
      return this.$store.getters.device;
    },
    siteName() {
      try {
        return this.site.get("rates").get("data").siteName;
      } catch (e) {
        return "";
      }
    },
    transitionName() {
      if (this.page) {
        return "off"; // no transition if page is forced
      } else {
        return "fade";
      }
    },
    legalNoticeLgLeft() {
      return this.ratesLg[this.currentLg].subtitles["1"];
    },
    legalNoticeLgMiddle() {
      return this.ratesLg[this.currentLg].subtitles["2"];
    },
  },
  watch: {
    netStatus(newStatus, oldStatus) {
      console.log("netStatus update", oldStatus, newStatus);
      // Get data on connection status change
      if (oldStatus) {
        // getData must not be done the first time
        console.log("netStatus getdata");
        this.$dm.getData(this.$route);
      }
    },
    user(newUser, oldUser) {
      console.log("User update", oldUser, newUser);
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log("user getdata");
        this.$dm.getData(this.$route);
      }
    },
    device(newDevice, oldDevice) {
      console.log("Device update", oldDevice, newDevice);
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log("device getdata");
        this.$dm.getData(this.$route);
      }
    },
    site(newSite, oldSite) {
      console.log("Site updated", oldSite, newSite);
    },
  },
  methods: {
    alternates() {
      if (this.ratesLg && this.ratesLg.lg2) {
        if (this.currentLg === "lg2") {
          this.currentLg = "lg1";
        } else {
          this.currentLg = "lg2";
        }
        if (this.lgTimeout) {
          clearTimeout(this.lgTimeout);
        }
        this.lgTimeout = setTimeout(this.alternates, 7000);
      }
    },
    space2br: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.replace(" ", "<br>");
    },
  },
};
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_tribe.scss";

#tribeRatesHorizontalV1 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
  background-color: black;
  color: white;

  #master {
    position: relative;
    width: 160vh;
    height: 100vh;
    text-transform: uppercase;

    #main {
      height: 100vh;
      @include heightPercent(887);
      @include widthPercent(1720);
      position: absolute;
      @include leftPercent(100);
      @include topPercent(100);
      border-top: 2px solid $white;

      .titleBloc {
        border-bottom: 1px solid $grey;
        @include heightPercent(77);

        .leftTitles {
          @include widthPercent(1040);

          .col2,
          .col3,
          .col4 {
            color: $white;
            font-family: "Brown";
            @include fontSize(20);
          }
        }
      }

      .ratesBloc {
        @include heightPercent(770);

        .left {
          @include widthPercent(1040);
        }

        .right {
          @include widthPercent(620);
        }
      }
    }

    #tribe_logo {
      position: absolute;
      @include heightPercent(75);
      @include widthPercent(125);
      @include leftPercent(1695);
      @include topPercent(1025);

      .cls-1 {
        fill: white;
      }
    }
  }
}
</style>

<style lang="scss">
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_tribe.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;
}

#tribeRatesHorizontalV1 {
  .white {
    color: $white;
    font-family: "Knockout", "Brown";
    @include fontSize(47);
  }

  .grey {
    font-family: "Brown";
    color: $grey;
    @include fontSize(25);
  }

  .col1 {
    @include widthPercent(500);
  }
  .col2,
  .col3,
  .col4 {
    @include widthPercent(175);
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/tribeRatesHorizontalV1.vue